import { type VariantProps, cva } from 'class-variance-authority'
import { RefreshCwIcon } from 'lucide-react'
import type * as React from 'react'

import { cn } from '@/lib/utils'

const spinnerVariants = cva('shrink-0', {
	variants: {
		size: {
			default: 'size-(--icon-standalone)',
			lg: 'size-6',
			xl: 'size-8',
		},
	},
	defaultVariants: {
		size: 'default',
	},
})

interface SpinnerProps extends React.ComponentProps<'svg'>, VariantProps<typeof spinnerVariants> {
	spinning?: boolean
}

function Spinner({ className, size, spinning = true, ...props }: SpinnerProps) {
	return (
		<RefreshCwIcon
			role={spinning ? 'status' : undefined}
			aria-label={spinning ? 'Loading' : undefined}
			className={cn(spinnerVariants({ size }), spinning && 'animate-spin', className)}
			{...props}
		/>
	)
}

export { Spinner, spinnerVariants }
